<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 320 320">
    <defs>
        <path d="M315.96 296.47C321.35 301.85 321.35 310.58 315.96 315.96C314.01 317.91 317.91 314.01 315.96 315.96C310.58 321.35 301.85 321.35 296.47 315.96C236.03 255.53 64.47 83.97 4.04 23.53C-1.35 18.15 -1.35 9.42 4.04 4.04C5.99 2.09 2.09 5.99 4.04 4.04C9.42 -1.35 18.15 -1.35 23.53 4.04C83.97 64.47 255.53 236.03 315.96 296.47Z" id="c2mr3I0Cxf">
        </path>
        <path d="M23.53 315.96C18.15 321.35 9.42 321.35 4.04 315.96C2.09 314.01 5.99 317.91 4.04 315.96C-1.35 310.58 -1.35 301.85 4.04 296.47C64.47 236.03 236.03 64.47 296.47 4.04C301.85 -1.35 310.58 -1.35 315.96 4.04C317.91 5.99 314.01 2.09 315.96 4.04C321.35 9.42 321.35 18.15 315.96 23.53C255.53 83.97 83.97 255.53 23.53 315.96Z" id="hhRNsojaX">
        </path>
    </defs>
    <g>
        <use xlink:href="#c2mr3I0Cxf" opacity="1" fill="#ffffff" fill-opacity="1"></use>
        <use xlink:href="#hhRNsojaX" opacity="1" fill="#ffffff" fill-opacity="1"></use>
    </g>
</svg>
